<template>
  <div class="mx-2 additional-car-information d-flex">
    <!-- Location state icon -->
    <div class="connection-information mr-3" :style="locationStateBackground">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-icon :color="locationStateColor" center v-bind="attrs" v-on="on">
            {{ locationStateIcon }}
          </v-icon>
        </template>
        <span>{{ $t(locationTooltipKey) }}</span>
      </v-tooltip>
    </div>

    <!-- Vehicle state icon -->
    <div class="connection-information" :style="vehicleStateBackground">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-icon :color="vehicleStateColor" center v-bind="attrs" v-on="on">
            {{ vehicleStateIcon }}
          </v-icon>
        </template>
        <span>{{ $t(vehicleStateTooltipKey) }}</span>
      </v-tooltip>
    </div>
  </div>
</template>

<script>
export default {
  name: "VehicleConnectionStateIcons",

  props: {
    isAtChargingLocation: {
      type: Boolean,
      default: false
    },
    isReachable: {
      type: Boolean,
      default: false
    },
    isPluggedIn: {
      type: Boolean,
      default: false
    },
    isCharging: {
      type: Boolean,
      default: false
    },
    isFullyCharged: {
      type: Boolean,
      default: false
    },
    isSmartChargingPaused: {
      type: Boolean,
      default: false
    },
    isSmartChargingOverriden: {
      type: Boolean,
      default: false
    },
    isChargeStateTransitioning: {
      type: Boolean,
      default: false
    },
    connectionInformationBackground: {
      type: String,
      default: ''
    }
  },

  computed: {
    locationStateIcon() {
      return this.isAtChargingLocation ? 'fmd_good' : 'wrong_location'
    },

    locationTooltipKey() {
      return this.isAtChargingLocation ? 'enode-connection-tile.at-location.tooltip'
                                       : 'enode-connection-tile.not-at-location.tooltip';
    },

    locationStateColor() {
      return this.isAtChargingLocation ? 'primary' : ''
    },

    locationStateBackground() {
      return this.isAtChargingLocation ? { backgroundColor: this.connectionInformationBackground } : {}
    },

    vehicleStateIcon() {
      if (this.isFullyCharged) return 'battery_full';
      if (!this.isReachable) return 'wifi_off';
      if (!this.isPluggedIn) return 'power_off';
      if (this.isSmartChargingPaused) return 'pause_circle';
      if (this.isSmartChargingOverriden) return 'flash_on';
      if (!this.isCharging) return 'flash_off';
      if (this.isCharging) return 'flash_auto';
      if (this.isChargeStateTransitioning) return 'autorenew';

      // default icon
      return 'bolt';
    },

    vehicleStateTooltipKey() {
      if (this.isFullyCharged) return 'enode-connection-tile.fully-charged.tooltip';
      if (!this.isReachable) return 'enode-connection-tile.not-reachable.tooltip';
      if (!this.isPluggedIn) return 'enode-connection-tile.not-plugged-in.tooltip';
      if (this.isSmartChargingPaused) return 'enode-connection-tile.charging-paused.tooltip';
      if (this.isSmartChargingOverriden) return 'enode-connection-tile.smart-charging-overridden.tooltip';
      if (!this.isCharging) return 'enode-connection-tile.not-charging.tooltip';
      if (this.isCharging) return 'enode-connection-tile.charging.tooltip';

      return '';
    },

    vehicleStateColor() {
      return this.isFullyCharged || this.isCharging || this.isSmartChargingOverriden ? 'primary' : '';
    },

    vehicleStateBackground() {
      return this.isFullyCharged || this.isCharging || this.isSmartChargingOverriden ?
        {backgroundColor: this.connectionInformationBackground} : {};
    },

  }
};
</script>